<template>
  <!-- <a-locale-provider :locale="locale">
    <div id="app" class="container">
      <router-view />
    </div>
  </a-locale-provider>-->
  <div class="update">
    <a href="javascript:;" class="downlink" @click="fnUpdate">
      <img src="https://gamesdownload-1304610428.file.myqcloud.com/20211215150148.png" alt />
    </a>
    <a href="javascript:;" class="btnClose" @click="fnClose">
      <svg
        t="1639551922248"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2015"
        width="128"
        height="128"
      >
        <path
          d="M544.448 499.2l284.576-284.576a32 32 0 0 0-45.248-45.248L499.2 453.952 214.624 169.376a32 32 0 0 0-45.248 45.248l284.576 284.576-284.576 284.576a32 32 0 0 0 45.248 45.248l284.576-284.576 284.576 284.576a31.904 31.904 0 0 0 45.248 0 32 32 0 0 0 0-45.248L544.448 499.2z"
          p-id="2016"
          fill="#ffffff"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import store from './store'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  data () {
    return {
      locale: zhCN,
      timer: null,
      timerFever: null,
      pids: ['A2D0C2FD2oEQ',
        'PIDrPMY1pgws',
        '9C9FB06D1JaC',
        'PIDPngj1tvSt',
        'PIDRwWQFpMWB',
        '9C9FB06D4p9N',
        'A2D0C2FD40AB',
        'A2D0C2FD8TeM',
        'C80015DD8e90',
        'masbz-fg9o3x64263',
        'PIDSUFHd4yEt',
        'PIDXF9XmnPMc',
        '50C2FB3C1RaH']
    }
  },
  mounted () {
    this.$nextTick(_ => {
      // 检测是否是未成年
      // this.underAge()
      // this.fnUpdate()
      window.CCJS = this.CCJS
      if (window !== top) {
        window.parent.postMessage(JSON.stringify({
          dataType: 'loadSuccess'
        }), '*')
      }
      this.fnCmdLine()
    })
  },
  methods: {
    CCJS (e) {
      console.log(e)
    },
    // 窗口关闭
    fnClose () {
      window.close()
    },
    // 获取命令行参数并解析pid
    fnCmdLine () {
      // t.$cookies.set('pid', arr.pid, '24h', '/', location.host.substr(location.host.indexOf('.')))
      let t = this
      t.fnCefGameBox({
        method: 'GetCommandParams',
        success: res => {
          let param = res.param || res.data.param
          if (res && param) {
            if (param.indexOf('--extend=') < 0) return
            let s = param.split('--extend=')[1]
            s = s.split('&')
            let str = ''
            s.forEach(item => {
              if (item.indexOf('pid=') > -1) {
                str = item.replace('pid=', '')
              }
            })
            console.log(str)
            t.$cookies.set('jspid', str, '24h', '/', location.host.substr(location.host.indexOf('.')))
            t.$cookies.set('pid', str, '24h', '/', location.host.substr(location.host.indexOf('.')))
          }
        }
      })
    },
    // 从v1升级至v2版本
    fnUpdate () {
      // return
      let pid = this.$cookies.get('jspid') || this.$cookies.get('pid') || ''
      console.log(pid)
      let idx = this.pids.findIndex(item => item === pid)
      let url = 'https://www.yilewan.com/Index/download?id=1938'
      if (pid && idx >= 0) {
        url = 'https://easydown.stnts.com/yilewan/ylwgamebox_' + pid + '.exe'
      }
      this.fnCefGameBox({
        method: 'clientOpenBrowser',
        data: {
          url
        },
        success: (res) => {
        }
      })
    },
    // 用户判断是否实名、成年、未成年，是否可玩
    underAge () {
      let t = this
      if (!store.state.USER.uid) {
        t.timer = setTimeout(this.underAge, 10 * 1e3)
        return
      }
      t.timer && clearTimeout(t.timer)
      t.XHR({
        url: t.ports.user.underAge,
        config: { withCredentials: true },
        cbFn: res_ => {
          if (res_.status === 'error') return
          if (!res_.data.adult && res_.data.canPlay === 3) {
            t.fnCefGameBox({
              method: 'clientOpenWnd',
              data: {
                url: 'https://account-api.yilewan.com/statics/aas/box.html',
                topmost: 1,
                status: 0,
                width: window.screen.width - 300,
                height: window.screen.height - 500
              },
              success: res => { }
            })
          }
          if (!res_.data.adult && res_.data.canPlay !== 3) {
            t.timerFever && clearTimeout(t.timerFever)
            t.timerFever = setTimeout(this.underAge, 60 * 1e3)
          }
        }
      })
    },
  }
}
</script>
<style lang="less">
@import url('./assets/var');
@import url('./assets/style');
@import url('./assets/welfare');
@import url('./assets/login');
.update {
  width: 100%;
  height: 100%;
  -webkit-app-region: drag;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  display: flex;
  flex-flow: column;
  align-items: center;
  .btnClose {
    position: fixed;
    right: 10px;
    top: 10px;
    transform: scale(0.3);
    transform-origin: top right;
    -webkit-app-region: no-drag;
    z-index: 92;
  }
  .downlink {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 740px;
    height: 460px;
    margin-top: -230px;
    margin-left: -370px;
    -webkit-app-region: no-drag;
    z-index: 91;
  }
}
</style>
